import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=716b477a&scoped=true&"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js&"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b477a",
  null
  
)

export default component.exports